export const HealthscoreTabs = {
  INSIGHTS: 'insights',
  DISCOVER: 'discover',
  IMPROVE: 'improve',
  ABOUT: 'about',
};
